export default __webpack_public_path__ + "static/media/coreos.c8baa3ee.svg";